module.exports = __webpack_public_path__ + "static/img/windows_FAQ_pic01.0ffc825.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/windows_FAQ/windows_FAQ_pic01.png
// module id = 598
// module chunks = 1